import React, {useRef, useEffect, useState} from 'react';
import LoadDataBtnView from '../View/LoadDataBtn.view';
import {IPropsController} from '../Config/LoadDataBtn.types';

const LoadDataBtn = ({
    classNameBtn,
    multiple,
    btnTitle = '',
    onUploadFiles = () => {},
    uploadOnlyOneFile,
    setRef,
    children,
    accept = '*',
    uploadImageSrc = ''}:IPropsController) => {
    const inputOpenFileRef:React.RefObject<HTMLInputElement> = useRef(null);
    const [counter, setCounter] = useState(0);
    const _preventDefault = (e) => e.preventDefault();

    const onClickInputFile = () => {
        if (inputOpenFileRef && inputOpenFileRef.current) {
            inputOpenFileRef.current.value = '';
            inputOpenFileRef.current.click();
        }
        setCounter(counter + 1);
    };

    useEffect(() => {
        (inputOpenFileRef.current !== null && setRef) && setRef(inputOpenFileRef);
    }, [inputOpenFileRef]);


    return <LoadDataBtnView
        _preventDefault={_preventDefault}
        btnTitle={btnTitle}
        setButtonToBeEnableAfterPress={counter}
        uploadImageSrc={uploadImageSrc}
        classNameBtn={classNameBtn}
        inputOpenFileRef={inputOpenFileRef}
        multiple={multiple}
        accept={accept}
        onUploadFiles={onUploadFiles}
        onClickInputFile={onClickInputFile}
        uploadOnlyOneFile={uploadOnlyOneFile} >{children}</LoadDataBtnView>;
};


export default LoadDataBtn;
